import React from 'react';
import './Leaderboard.css';

const Leaderboard = () => {
  return (
    <div className="leaderboard-container">
      <h2>Leaderboard</h2>
      <p>Top players and their scores will appear here.</p>
    </div>
  );
};

export default Leaderboard;